import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  uploadDocument,
  uploadDocumentLogs,
} from "../../Redux/IndividualMedicalRedux";
import { useLocation, useNavigate } from "react-router-dom";
import { documentUpload } from "../../Redux/loadingReducer";
import { useTranslation } from "react-i18next";
import CustomModal from "../Common/CustomModal/CustomModal";
import { validatePdfUploadFile } from "./uploadValidation";

function UploadDocument({ isSuccess, planDetails: planDetailsProp }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const planDetails = planDetailsProp || location.state?.planDetails || {};
  const policyNumber = planDetails?.policyResult?.policy_number;
  const encodedPolicyNumber = encodeURIComponent(policyNumber);
  const coverPlan = planDetails?.coverPlan;

  const [selectedDoc, setSelectedDoc] = useState("passport");
  const [selectedDocCivil, setSelectedDocCivil] = useState("CivilId");
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState();
  const [isSummaryOpen, setIsSummaryOpen] = useState(false);
  const [selectedPdf, setSelectedPdf] = useState(null);

  const [file1, setFile1] = useState(null);
  const [errorUploading, setErrorUploading] = useState("");

  const [message, setMessage] = useState("");
  const [message1, setMessage1] = useState("");
  const { documentUploaded } = useSelector((state) => state.loading);

  const getBackendErrorMessage = (result) => {
    if (!result) return "";

    if (result?.errors?.data && typeof result.errors.data === "object") {
      const firstFieldError = Object.values(result.errors.data).find(
        (item) => item?.message,
      );
      if (firstFieldError?.message) return firstFieldError.message;
    }

    if (typeof result?.errors?.message === "string" && result.errors.message.trim()) {
      return result.errors.message;
    }

    if (Array.isArray(result?.errors?.message) && result.errors.message.length > 0) {
      return result.errors.message[0];
    }

    if (typeof result?.message === "string" && result.message.trim()) {
      return result.message;
    }

    if (typeof result?.error === "string" && result.error.trim()) {
      return result.error;
    }

    return "Error uploading documents";
  };

  const validatePdfFile = (e, setFileFunc, setMessageFunc) => {
    const uploadedFile = e.target.files[0];
    if (!uploadedFile) return;
    setMessageFunc("");

    const { isValid, errorMessage } = validatePdfUploadFile(uploadedFile);

    if (!isValid) {
      setMessageFunc(errorMessage);
      setFileFunc(null);
      return;
    }

    setFileFunc(uploadedFile);
  };

  const handleFileChange = (e) => {
    validatePdfFile(e, setFile, setMessage);
  };

  const handleFileChange1 = (e) => {
    validatePdfFile(e, setFile1, setMessage1);
  };

  const handleView = (fileToView) => {
    if (!fileToView) return;
    if (selectedPdf) {
      URL.revokeObjectURL(selectedPdf);
    }
    const url = URL.createObjectURL(fileToView);
    setSelectedPdf(url);
    setFileName(fileToView.name);
    setIsSummaryOpen(true);
  };

  const handleSubmit = () => {
    if (!file) {
      setMessage("Please select a file to upload.");
      return;
    }
    if (coverPlan !== "Individual Medical" && !file1) {
      setMessage1("Please select a file to upload.");
      return;
    }
    const formData = new FormData();
    formData.append("passportCopyWithVisaPageOrResidentId", file);

    if (coverPlan !== "Individual Medical") {
      formData.append("sponsorResidentIdOrPassportWithVisaPage", file1);
    }
    dispatch(uploadDocument(formData, encodedPolicyNumber))
      .then((result) => {
        setErrorUploading("");

        if (!result?.success) {
          setErrorUploading(getBackendErrorMessage(result));
          return;
        }

        return dispatch(
          uploadDocumentLogs(
            formData,
            localStorage.getItem("MEDICAL_QUOTE_ID"),
          ),
        );
      })
      .then((response) => {
        if (!response) return;

        if (response.success) {
          dispatch(documentUpload(true));
          setErrorUploading("");
        }
      })
      .catch(() => {
        setErrorUploading("Error uploading documents");
      });
  };

  const handleNext = () => {
    navigate("/summary", {
      state: { planDetails },
    });
  };

  return (
    <>
      {!documentUploaded && (
        <>
          <h6 className="titleModal p-0 mt-3">{t("UPLOAD DOCUMENT")}</h6>
          <div className="plan-card-plan border p-3 mb-4">
            <div className="py-1">
              <p className="fw-bold mb-0">
                {t("Allowed .pdf file type only")}.
              </p>
            </div>
            <div className="mb-3">
              <label className="form-label fw-bold">
                {t("Select Document")}
              </label>
              <select
                className="form-select"
                value={selectedDoc}
                onChange={(e) => setSelectedDoc(e.target.value)}
              >
                <option value="passport">
                  {t("Resident ID (Civil ID) or Passport")}
                </option>
              </select>

              {/* Show file upload when passport option selected */}
              {selectedDoc === "passport" && (
                <div className="mt-3">
                  <label className="form-label">
                    {t("Upload your document")}
                  </label>
                  <input
                    type="file"
                    className="form-control"
                    accept=".pdf"
                    onChange={handleFileChange}
                  />

                  {file && (
                    <div className="mt-2 text-success d-flex justify-content-between align-items-center">
                      <span>
                        {/* {t("Uploaded")}:  */}
                        <strong>{file.name}</strong>
                      </span>

                      <span
                        className="linkView"
                        role="button"
                        onClick={() => handleView(file)}
                        style={{ cursor: "pointer" }}
                      >
                        {t("View")}
                      </span>
                    </div>
                  )}

                  {message && (
                    <p className="mt-2 text-danger">
                      <strong>{t(message)}</strong>
                    </p>
                  )}
                </div>
              )}
            </div>
            {coverPlan !== "Individual Medical" && (
              <div className="mb-3">
                <label className="form-label fw-bold">
                  {t("Select Document")}
                </label>
                <select
                  className="form-select"
                  value={selectedDocCivil}
                  onChange={(e) => setSelectedDocCivil(e.target.value)}
                >
                  <option value="CivilId">
                    {t("Sponsor Resident ID or Passport")}
                  </option>
                </select>

                {/* Show file upload when passport option selected */}
                {selectedDocCivil === "CivilId" && (
                  <div className="mt-3">
                    <label className="form-label">
                      {t("Upload your document")}
                    </label>
                    <input
                      type="file"
                      className="form-control"
                      accept=".pdf"
                      onChange={handleFileChange1}
                    />
                    {file1 && (
                      <div className="mt-2 text-success d-flex justify-content-between align-items-center">
                        <span>
                          {/* {t("Uploaded")}:  */}
                          <strong>{file1.name}</strong>
                        </span>
                        <span
                          className="linkView"
                          role="button"
                          onClick={() => handleView(file1)}
                          style={{ cursor: "pointer" }}
                        >
                          {t("View")}
                        </span>
                      </div>
                    )}
                    {message1 && (
                      <p className="mt-2 text-danger">
                        <strong>{t(message1)}</strong>
                      </p>
                    )}
                  </div>
                )}
              </div>
            )}
            {/* {coverPlan !== "Individual Medical" && (
              <label className="form-label">
                {t("Either a Resident ID (Civil ID) or Passport is required.*")}
              </label>
            )} */}
            <div
              className={`col-12 my-2 ${i18n.language === "ar" ? "text-start" : "text-end"} mb-3`}
            >
              {/** enable only when required files are present and no validation messages */}
              <button
                type="button"
                className="btn btn-primary py-2 px-4"
                onClick={() => handleSubmit()}
                disabled={
                  !file ||
                  (coverPlan !== "Individual Medical" && !file1) ||
                  !!message ||
                  !!message1 ||
                  documentUploaded
                }
              >
                {t("Upload")}
              </button>
              {errorUploading && (
                <div className="mt-2 text-danger small">{errorUploading}</div>
              )}
            </div>
          </div>
        </>
      )}
      {documentUploaded && (
        <div className="py-4">
          <div
            className="card d-flex justify-content-center align-items-center  p-4"
            style={{ borderRadius: "12px", borderColor: "#cd7f43" }}
          >
            <div className="card-body d-flex justify-content-center align-items-center p-0">
              <i className="success-icon-animated bi bi-check-circle text-success"></i>
            </div>
            <label className="fw-semibold">
              {t("Documents uploaded successfully")}.
            </label>

            <hr className="w-100" />
            {file && (
              <div className=" text-success d-flex justify-content-between align-items-center w-100">
                <span>
                  <strong className="uploadedName">{file.name}</strong>
                </span>

                <span
                  className="linkView"
                  role="button"
                  onClick={() => handleView(file)}
                  style={{ cursor: "pointer" }}
                >
                  {t("View")}
                </span>
              </div>
            )}

            {file1 && (
              <div className="mt-2 text-success d-flex justify-content-between align-items-center w-100">
                <span>
                  <strong className="uploadedName">{file1.name}</strong>
                </span>

                <span
                  className="linkView"
                  role="button"
                  onClick={() => handleView(file1)}
                  style={{ cursor: "pointer" }}
                >
                  {t("View")}
                </span>
              </div>
            )}
            <hr className="w-100" />
            <p className="text-muted small m-0">
              {t("Your document have been successfully submitted")}
            </p>
            <p className="text-muted small m-0">
              {t("Press")} "<b>{t("Next")}</b>" {t("to continue")}
            </p>
          </div>

          <div
            className={`col-12 mt-3 ${i18n.language === "ar" ? "text-start" : "text-end"}`}
          >
            {/** enable only when required files are present and no validation messages */}
            <button
              type="button"
              className="btn btn-primary py-2 px-3"
              onClick={() => handleNext()}
            >
              {t("Next")}
            </button>
          </div>
        </div>
      )}
      {/* preview modal for any selected file */}
      <CustomModal
        isOpen={isSummaryOpen}
        onClose={() => {
          setIsSummaryOpen(false);
          if (selectedPdf) {
            URL.revokeObjectURL(selectedPdf);
            setSelectedPdf(null);
            setFileName(null);
          }
        }}
        title={fileName || "Document Preview"}
        pdfUrl={selectedPdf}
      >
        <div
          className="modal-body"
          style={{ overflow: "hidden", padding: 0, height: "70vh" }}
        >
          {selectedPdf && (
            <iframe
              title="View Document"
              src={`${selectedPdf}#page=1&toolbar=0`}
              width="100%"
              height="95%"
              style={{ border: "none" }}
            />
          )}
        </div>
      </CustomModal>
    </>
  );
}

export default UploadDocument;
